import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { openModal } from '@frontend-mono/shared/modal/util-open-modal'
import { CloseModalFn } from '@frontend-mono/shared/modal/util-types'
import { ModalContent } from './ModalContent'

export const usePlaylistModal = (afterUpdateCallback?: () => void) => {
  const { t } = useTranslation()
  const router = useRouter()

  const handleOpenToast = (targetId: string, closeParent: CloseModalFn) => {
    openModal({
      title: t('Topic_playlist_complete_title'),
      icon: 'modalComplete',
      content: t('Topic_playlist_complete_question'),
      primaryButton: {
        text: t('Topic_playlist_complete_move'),
        onClick: (close) => {
          close()
          closeParent()
          router.push(`/dashboard/playlists/${targetId}`)
        },
      },
      secondaryButton: {
        text: '닫기',
        onClick: (close) => {
          close()
          closeParent()
        },
      },
    })
  }

  const open = (topicIdList: string[]) => {
    if (!topicIdList.length) return

    const content = (close: CloseModalFn) => (
      <ModalContent
        topicIdList={topicIdList}
        afterUpdateCallback={(targetId) => {
          handleOpenToast(targetId, close)
          if (afterUpdateCallback) {
            afterUpdateCallback()
          }
        }}
      />
    )
    openModal({
      title: null,
      width: '40.9rem',
      content,
      hasXButton: true,
    })
  }

  return {
    open,
  }
}
